import { useTranslation } from "react-i18next";
import { useAppDispatch } from "../../../../hooks/useTypedSelector";
import { logout } from "../../../auth/infrastructure/slices/authSlice/authSlice";
import { Breadcrumb } from "../../../general/modules/commons/breadcrumb/breadcrumb";
import {
  Layout,
  LayoutContent,
  LayoutHeader,
  LayoutHeaderActions,
  LayoutHeaderTitle,
} from "../../../general/modules/commons/layout/layout";
import { RelationMutateNavigation } from "../features/RelationMutateNavigation";
import useCrudTable from "../../../../hooks/useCrudTable";
import {
  customerColumns,
  customerSchema,
} from "../../../customer/domain/model/CustomerModel";
import { Content } from "../../../general/modules/commons/content/content";
import { ContentHeader } from "../../../general/modules/commons/content/contentHeader";
import { Outlet, useParams } from "react-router-dom";
import useCrudFilters from "../../../../hooks/useCrudFilters";

export const RelationCustomersPage = () => {
  const dispatch = useAppDispatch();

  const { t } = useTranslation("common");

  const { id } = useParams();

  const { filters } = useCrudFilters({
    searchBy: "SearchByRootCustomer",
    fields: {
      relation: {
        fields: {
          id: {
            equal: id,
          },
        },
      },
    },
  });

  const crud = useCrudTable({
    prefix: "customers",
    entity: "Customer",
    columns: customerColumns,
    schema: customerSchema,
    addAction: `/relations/edit/${id}/customers/add`,
    columnAction: `/relations/edit/${id}/customers/:id/edit`,
    filters: id ? filters : undefined,
    defaultSorting: [
      {
        id: "name",
        desc: false,
      },
    ],
  });

  return (
    <Layout
      header={
        <LayoutHeader logout={() => void dispatch(logout())}>
          <LayoutHeaderTitle title={t("relation.mutate.customers")} />
          <Breadcrumb></Breadcrumb>
          <LayoutHeaderActions>{crud.addButton}</LayoutHeaderActions>
        </LayoutHeader>
      }
    >
      <LayoutContent>
        <RelationMutateNavigation />
        <Content>
          <ContentHeader title={t("Customer")} />
          {crud.table}
        </Content>
        <Outlet />
      </LayoutContent>
    </Layout>
  );
};
